import { Stack, Typography } from "@mui/material";
import { BackButton, StyledLink } from "react-common-ui-library";
import { useIntl } from "react-intl";
import {
  StyledLinkApplicationBackButtonBox,
  StyledLinkApplicationSubTextBox,
} from "../../../Styles/LinkApplication/LinkMyApplication";
import LinkMyApplicationForm from "./LinkMyApplicationForm";

import { useNavigate } from "react-router-dom";
import {
  ACCOUNT_CREATION_ROUTE,
  BACK_BUTTON_TEXT,
  BUTTON,
  H1,
  H3,
  LOGIN_ROUTE,
  P_REGULAR,
  SECONDARY_MAIN,
} from "../../../Constants/CommonConstants";
import {
  LINK_APPLICATION_ALREADY_TEXT,
  LINK_APPLICATION_BACK_BUTTON_ID,
  LINK_APPLICATION_HEADING,
  LINK_APPLICATION_TEXT,
  LINK_APPLICATION_TEXT_LOGIN,
} from "../../../Constants/LinkMyApplicationConstants";

/**
 * @description Link My Application screen allows the user view the heading and subtext
 * @returns {ReactNode} Renders the Link My Application Screen which has the heading, subtext and LinkMyApplicationForm component
 */
const LinkMyApplication = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const onBackClickHandler = () => {
    navigate(`/${ACCOUNT_CREATION_ROUTE}`);
  };

  const handleLoginClick = () => {
    navigate(`/${LOGIN_ROUTE}`);
  };

  return (
    <Stack spacing={5}>
      <Stack spacing={{ xs: 3, md: 5 }}>
        <StyledLinkApplicationBackButtonBox>
          <BackButton
            id={LINK_APPLICATION_BACK_BUTTON_ID}
            backButtonText={intl.formatMessage({ id: BACK_BUTTON_TEXT })}
            backButtonOnClickHandler={onBackClickHandler}
          />
        </StyledLinkApplicationBackButtonBox>
        <Stack spacing={{ xs: 2.5, md: 2 }}>
          <Typography
            component={H1}
            variant={H3}
            color={SECONDARY_MAIN}
            id={LINK_APPLICATION_HEADING}
          >
            {intl.formatMessage({ id: LINK_APPLICATION_HEADING })}
          </Typography>
          <StyledLinkApplicationSubTextBox>
            <Typography variant={P_REGULAR} id={LINK_APPLICATION_TEXT}>
              {intl.formatMessage({ id: LINK_APPLICATION_ALREADY_TEXT })}
            </Typography>
            <StyledLink
              id={LINK_APPLICATION_TEXT_LOGIN}
              component={BUTTON}
              type={BUTTON}
              onClick={handleLoginClick}
            >
              {intl.formatMessage({ id: LINK_APPLICATION_TEXT_LOGIN })}
            </StyledLink>
          </StyledLinkApplicationSubTextBox>
        </Stack>
      </Stack>
      <LinkMyApplicationForm />
    </Stack>
  );
};

export default LinkMyApplication;
